var _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorLungSageataFinalSus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 80,
    viewBox: "0 0 116 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 39.25,
    x2: 112,
    y2: 39.25,
    stroke: "black",
    strokeWidth: 5.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 39.5L58.75 68.5118V10.4881L115 39.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorLungSageataFinalSus);
export default __webpack_public_path__ + "static/media/conductor_lung_sageata_final_sus.87664fee16db91895859fd56ccd797da.svg";
export { ForwardRef as ReactComponent };